import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import {
  borderRadius,
  borderWidth,
} from "../../../design-system/tokens/borders";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const OverviewRoot = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ColumnsSection = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: ${borderWidth[1]} solid ${rawColors.stroke[200]};
`;

/** Grid only — padding here so the toggle row stays full-width (chevron aligned right). */
export const ColumnsGridWrap = styled.div`
  padding: ${spacing[4]} ${spacing[3]} ${spacing[3]};
`;

export const SourceLogo = styled.img`
  width: 14px;
  height: 14px;
  object-fit: contain;
  flex-shrink: 0;
`;

export const SourceName = styled.span`
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.highEmphasis};
`;

export const SourceValue = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[1]};
`;

export const SourceLinkButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  color: ${rawColors.text.mediumEmphasis};
  flex-shrink: 0;

  &:hover {
    color: ${rawColors.primary[500]};
  }
`;

export const FieldListValue = styled.span`
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.highEmphasis};
`;

export const PreviewRowList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[1]};
  padding: 0 ${spacing[3]} ${spacing[3]};
`;

export const PreviewRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing[2]};
  padding: ${spacing[2]};
  background-color: ${rawColors.structural[100]};
  border: ${borderWidth[1]} solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.md};
`;

export const PreviewRowName = styled.span`
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.highEmphasis};
  min-width: 0;
`;

export const ShowAllHint = styled.span`
  ${typographyMixin("caption", 4)}
  color: ${rawColors.primary[500]};
  padding: ${spacing[1]} ${spacing[2]} 0;
`;
